import EntityBaseRepository from '@/api/EntityBaseRepository';
import { AxiosResponse } from 'axios';

export default class ReportsRepository extends EntityBaseRepository {

    // --- Overview ---
    public getOverviewStats(): Promise<AxiosResponse> {
        return this.axiosClient.get('/reports/overview');
    }

    // --- Labels ---
    public getTopLabels(year?: number, limit = 50): Promise<AxiosResponse> {
        const params = new URLSearchParams();
        if (year) params.append('year', String(year));
        params.append('limit', String(limit));
        return this.axiosClient.get(`/reports/labels/top?${params}`);
    }

    public getLabelsByYear(): Promise<AxiosResponse> {
        return this.axiosClient.get('/reports/labels/by-year');
    }

    public getLabelStats(): Promise<AxiosResponse> {
        return this.axiosClient.get('/reports/labels/stats');
    }

    // --- Projects ---
    public getProjectStats(): Promise<AxiosResponse> {
        return this.axiosClient.get('/reports/projects/stats');
    }

    public getProjectsByCustomer(): Promise<AxiosResponse> {
        return this.axiosClient.get('/reports/projects/by-customer');
    }

    public getProjectsOpenMaintenance(): Promise<AxiosResponse> {
        return this.axiosClient.get('/reports/projects/open-maintenance');
    }

    public getProjectsUpcomingMaintenance(months = 6): Promise<AxiosResponse> {
        return this.axiosClient.get('/reports/projects/upcoming-maintenance', {
            params: { months },
        });
    }

    // --- Customers ---
    public getCustomerStats(): Promise<AxiosResponse> {
        return this.axiosClient.get('/reports/customers/stats');
    }

    // --- Technical ---
    public getTechnicalStats(): Promise<AxiosResponse> {
        return this.axiosClient.get('/reports/technical/stats');
    }

    // --- Actuator Units (Messwerte Übersicht) ---
    /** Gibt alle einzigartigen Kombinationen von Antriebstyp + Bezeichnung Einheit zurück,
     *  jeweils mit der Anzahl der Maschinen, die diese Kombination haben */
    public getActuatorStats(): Promise<AxiosResponse> {
        return this.axiosClient.get('/reports/actuator-stats');
    }

    /** Neu angelegte Antriebe je Antriebstyp, gruppiert nach Monat und Jahr */
    public getActuatorTypesByMonth(): Promise<AxiosResponse> {
        return this.axiosClient.get('/reports/actuator-types/by-month');
    }
}
